import RestService from "./RestService";

export default class WebTextService extends RestService {
  constructor() {
    super("/api/webtext");
  }
}
